module.exports = __webpack_public_path__ + "img/img_level_12.c801b99d.png";